import * as routes from 'api/routes';

export type Params = void;
export type Result = { message: string };
export const ROUTE = routes.AUTH_SESSION_OUT;
